import React, { useContext } from 'react';
import { Switch } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

const TooltipsOption = () => {
  const { showTooltips, setShowTooltips } = useContext(UserProfileContext);

  const handleChange = (checked: boolean) => {
    setShowTooltips(checked);
  };

  const _helpMessage = (
    <>
      <b>Security: </b>
      <br />
      Role must be "System Administrator" or better.
    </>
  );

  return (
    <IBTooltip content={_helpMessage}>
      Tooltips{'   '} <Switch value={showTooltips} onChange={handleChange} />
    </IBTooltip>
  );
};

export default TooltipsOption;
